import { BotId, NlpModel, NlpExample, Dictionary, BotDefaultLocale } from '@feedyou/schema'
import { UtteranceClassification } from '@feedyou/utils'

import { alert } from '../../lib/bootbox'
import { getApiUrl } from '../../apiService'
import { serverApi } from '../../store/serverApi'
import { toastNotifyProcessUtteranceError } from './toasts'
import { generateBootboxReportFromClassifications } from './utils'

export const nlpAnalyzerApi = serverApi.injectEndpoints({
  endpoints: builder => ({
    classifyUtterance: builder.mutation<
      | { classificationsPerUtterance: Dictionary<NlpExample, UtteranceClassification[]> }
      | undefined,
      {
        botId: BotId
        models: NlpModel[]
        utterance: NlpExample
        botDefaultLocale?: BotDefaultLocale
      }
    >({
      query: ({ botId, models, utterance, botDefaultLocale }) => ({
        method: 'POST',
        url: getApiUrl('/nlp-analyzer/classify'),
        body: { models, botDefaultLocale, utterances: [utterance] },
        headers: {
          'x-user-authentication-against-bot-id': botId
        }
      }),
      onQueryStarted: async (arg, api) => {
        try {
          const { data: response } = await api.queryFulfilled
          const classifications = response?.classificationsPerUtterance?.[arg.utterance] || []

          await alert({
            className: 'no-footer-border',
            title: `Utterance "${arg.utterance}" matched the following intents:`,
            message: generateBootboxReportFromClassifications(arg.models, classifications)
          })
        } catch (error) {
          toastNotifyProcessUtteranceError(arg.utterance)
        }
      }
    })
  })
})
